import { Icon, Modal } from '@components';
import { Button, Flex, theme, Typography } from '@styles';
import { ReactComponent as CloseIcon } from '@svgs/close.svg';
import { ReactComponent as FilterIcon } from '@svgs/filter-green.svg';
import { ReactComponent as LinkIcon } from '@svgs/link.svg';
import { func } from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { filterNavigationProps } from './FilterNavigation.layoutProps';

const FilterNavigation = ({
  // checkNotifications,
  onNavigationButtonClick,
}) => {
  const { i18n } = useTranslation();

  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  const activitiesSideContentState = useSelector(
    (state) => state.activitiesSlice.activitiesSideContentState
  );

  const toggleFilterModal = () => {
    setIsFilterModalVisible((prevState) => !prevState);
  };

  const handleClick = (id) => () => {
    onNavigationButtonClick(id)();
    toggleFilterModal();
  };

  const filterNavigationElements = filterNavigationProps.map(
    (navigationButton, index) => (
      <Button
        key={`${navigationButton.id}-${navigationButton.titleText}`}
        height={45}
        onClick={handleClick(navigationButton.id)}
        px={24}
        variant={
          navigationButton.id === activitiesSideContentState
            ? 'primary'
            : 'secondary'
        }
        whiteSpace="nowrap"
        width="fit-content"
        {...((index === 0 || index === filterNavigationProps.length - 2) && {
          mb: '8px',
        })}
        position="relative"
      >
        {/* {checkNotifications(navigationButton.type) && (
          <Flex
            backgroundColor={theme.colors.schoolBusYellow[100]}
            border={`0.5px solid ${theme.colors.black[100]}`}
            borderRadius={6}
            height={11}
            position="absolute"
            right={-4}
            top={0}
            width={11}
            zIndex={100}
          />
        )} */}
        <Typography
          color={
            navigationButton.id === activitiesSideContentState
              ? theme.colors.black[100]
              : theme.colors.white[100]
          }
          display="inline"
          variant={
            navigationButton.id === activitiesSideContentState
              ? 'MS-bold-s16-lh25'
              : 'MS-semibold-s16-lh25'
          }
        >
          {i18n.t(navigationButton.titleText).toUpperCase()}
        </Typography>
        {navigationButton.id === 'seeMore' && (
          <Icon
            color={
              navigationButton.id === activitiesSideContentState
                ? theme.colors.black[100]
                : theme.colors.white[100]
            }
            ml={3}
            SVG={LinkIcon}
          />
        )}
      </Button>
    )
  );

  return (
    <>
      <Modal
        alignItems="flex-end"
        isVisible={isFilterModalVisible}
        justifyContent="center"
        modalContainerProps={{
          backgroundColor: 'transparent',
          borderRadius: '0px',
          height: '100%',
          m: 0,
          maxHeight: '100%',
          maxWidth: '100vw',
          width: '100%',
        }}
        modalMaxHeight="100%"
        setModalVisible={setIsFilterModalVisible}
        withBackdropNoise
        withCloseIcon={false}
      >
        <Flex
          backdropFilter="blur(16px)"
          backgroundColor="rgba(19, 28, 18, 0.60)"
          borderTopLeftRadius={8}
          borderTopRightRadius={8}
          bottom={0}
          flexDirection="column"
          gap={24}
          height="fit-content"
          pb={30}
          position="relative"
          pt={16}
          px={16}
          width="100%"
        >
          <Flex position="absolute" right={2} top={2} zIndex={10}>
            <Button
              height={48}
              onClick={toggleFilterModal}
              variant="textButton"
              width={48}
            >
              <Icon SVG={CloseIcon} />
            </Button>
          </Flex>
          <Typography
            color={theme.colors.white[100]}
            variant="BN-regular-s36-lh43"
          >
            {i18n.t('ProfilePage.Filter').toUpperCase()}
          </Typography>
          <Flex flexDirection="column" gap={16} mb={32}>
            {filterNavigationElements}
          </Flex>
          <Flex justifyContent="center" width="100%">
            <Button
              maxWidth={343}
              onClick={toggleFilterModal}
              variant="primary"
              width="100%"
            >
              <Typography
                color={theme.colors.black[100]}
                variant="MS-bold-s16-lh25"
              >
                {i18n.t('ProfilePage.Save').toUpperCase()}
              </Typography>
            </Button>
          </Flex>
        </Flex>
      </Modal>
      <Flex
        bottom={30}
        justifyContent="center"
        left={0}
        position="fixed"
        right={0}
        width="100%"
        zIndex={10}
      >
        <Button
          gap={8}
          maxWidth={343}
          onClick={toggleFilterModal}
          variant="primary"
          width="100%"
        >
          <Icon color={theme.colors.black[100]} SVG={FilterIcon} />
          <Typography
            color={theme.colors.black[100]}
            variant="MS-bold-s16-lh25"
          >
            {i18n.t('ProfilePage.Filter').toUpperCase()}
          </Typography>
        </Button>
      </Flex>
    </>
  );
};

FilterNavigation.propTypes = {
  checkNotifications: func.isRequired,
  onNavigationButtonClick: func.isRequired,
};

export default FilterNavigation;
